import React, { useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';

/**
 * LordIcon component - A wrapper around the Lordicon Player component
 * 
 * @param {Object} props - Component props
 * @param {Object} props.icon - The icon data JSON
 * @param {number} props.size - The size of the icon in pixels (default: 32)
 * @param {string} props.trigger - Animation trigger type (hover, click, loop, morph)
 * @param {string} props.colors - Color customization in format "primary:#ff0000,secondary:#00ff00"
 * @param {string} props.state - Animation state name
 * @param {string} props.className - Additional CSS class names
 * @param {Function} props.onClick - Click handler function
 */
const LordIcon = ({ 
  icon, 
  size = 32, 
  trigger = 'hover',
  colors,
  state,
  className = '',
  onClick,
  ...rest
}) => {
  const playerRef = useRef(null);
  
  useEffect(() => {
    // Play animation when component mounts if trigger is loop
    if (trigger === 'loop' && playerRef.current) {
      playerRef.current.playFromBeginning();
    }
  }, [trigger]);

  // Handle animation triggers
  const handleMouseEnter = () => {
    if (trigger === 'hover' && playerRef.current) {
      playerRef.current.playFromBeginning();
    }
  };

  const handleClick = (e) => {
    if (trigger === 'click' && playerRef.current) {
      playerRef.current.playFromBeginning();
    }
    
    // Pass the click event to the parent component if onClick is provided
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div 
      className={`inline-flex items-center justify-center ${className}`} 
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
      style={{ width: size, height: size }}
      {...rest}
    >
      <Player
        ref={playerRef}
        icon={icon}
        size={size}
        state={state}
        colors={colors}
      />
    </div>
  );
};

export default LordIcon; 